module.exports = __webpack_public_path__ + "static/media/51.78e6848c.svg";